import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import PaginationSection from '../../components/Product/Pagination';
import SupportPopup from '../../components/Popup/SupportPopup';
import instance from "../../services/services";
import { MAKING_SUPPORT_LIST_URL } from "../../utils/urls";
import { formatLocalString } from "../../utils/validation";
import SupportGuidePopup from '../../components/Popup/SupportGuidePopup';
import useUserStore from "../../store/userStore";
import PopupLoginError from "../../components/Popup/LoginError";
import { useLanguage } from "../../hooks/useLanguage";


function SupportList(){
  const { t } = useLanguage();
  const navigate = useNavigate();
  const [supportPop, setSupportPop] = useState(false);
  const [totalCount, setTotalCount] = useState(0);
  const [supportList, setSupportList] = useState([]);
  const itemsPerPage = 20; // 페이지당 표시할 항목 수
  const [currentPage, setCurrentPage] = useState(1);
  const [thisMonthData, setThisMonthData] = useState({});
  const [currentMonthData, setCurrentMonthData] = useState({});
  const [lastMonthData, setLastMonthData] = useState({});
  const [selectedWorkSeq, setSelectedWorkSeq] = useState(null);
  const { memberTokens } = useUserStore();
  const [isPopupLoginError, setIsPopupLoginError] = useState(false);

  // 제작지원 가이드 팝업
  const [isSupportGuidePopup, setSupportGuidePopup ] = useState(false);
  const handleSupportGuidePopup = () => {
    setSupportGuidePopup(true)
  };
  
  const handleClickForm = () => {
    if (!memberTokens) {
      setIsPopupLoginError({
        message: t('login_required'),
        action: 'navigate_login'
      });
      return;
    }

    navigate('/community/support/write');
  };

  const handleConfirm = () => {
    navigate('/login');
  };

  const handleViewMore = (workSeq) => {
    setSelectedWorkSeq(workSeq);
    setSupportPop(true);
  };

  useEffect(()=> {
    const fetchSupportList = async () => {
      try{
        const response = await instance.post(MAKING_SUPPORT_LIST_URL,{
          offset: currentPage,
          limit: itemsPerPage
        });
        setTotalCount(response.data.data.total_count);
        setSupportList(response.data.data.data);
        setThisMonthData(response.data.data.this_month); // 이번달 데이터
        setCurrentMonthData(response.data.data.this_month_guide); // 현재 달 데이터
        setLastMonthData(response.data.data.last_month); // 지난 달 데이터

      } catch (error) {
        console.error("제작지원 리스트 가져오기 실패:", error);
      }
    };
    fetchSupportList();
  }, [currentPage]);

    // 페이지 변경 핸들러
    const handlePageChange = (page) => {
      setCurrentPage(page);
    };
  
    // 화살표 클릭 핸들러
    const handleArrowClick = (page) => {
      handlePageChange(page);
    };


  return(
    <div className="board_container">
      <h3 className="commu_title noline">{t("production_support")}</h3>
      <ul className="support_header">
        <li className="info_item">
          <div className="flex-center column">
            {currentMonthData?.support_flag === 'Y' &&
              <span className="sm_txt">{t("current_applicant_0617")}</span>
            }
            <div className="flex-center-2 column">
              {currentMonthData?.support_flag === 'Y' &&
              <span className="b1_1">
                <strong className="lg_txt">{thisMonthData?.count || 0}</strong>{t("current_applicant_2_0617")}
              </span>
              }

              {currentMonthData?.support_flag === 'Y' ?
              <span className="p3_1 mt_10">{t('current_applicant_3_0617')} {thisMonthData?.applicationPeriod}</span>
              :
              <span className="p3_1 mt_10" >{t('production_support_ended')}</span>
              }
            </div>
          </div>
          <div className="flex-center-4 column">
            <span className="sm_txt">{t("production_support_notice")}</span>
            <p className="apply_box">
              <button 
                className="support_apply"
                onClick={handleSupportGuidePopup}
              >
                {t("guide_notice")}
              </button>
              <i></i>
              {currentMonthData?.support_flag === 'Y' ?
              <button
                type="button"
                className="support_apply"
                onClick={handleClickForm}
              >
                {t("production_support_application")}
              </button>
              :
              <button
                type="button"
                className="support_apply"
                onClick={handleClickForm}
                style={{color: 'gray'}}
                disabled={true}
              >
                {t('production_support_application')}
              </button>
              }
            </p>
          </div> 
        </li>
        {currentMonthData?.start_day === "" ? (
          <li className="info_item">
            <div className="flex-center column">
              <div className="flex-center-4 column info">
                <span className="p3_1 mt_10">{currentMonthData?.description}</span>
              </div>
            </div>
          </li>
        ) : (
          <li className="info_item">
            <div className="flex-center column">
              <span className="b1_1">
                <strong className="lg_txt">{currentMonthData?.application_month}</strong>{t("month_0617")}
              </span>
              <div className="flex-center-4 column info">
                <span className="sm_txt mt_10">{currentMonthData?.description}</span>
                <span className="p3_1">{t("application_period_0617")} {currentMonthData?.start_day}{t("total_rental_days_count_0417_2")} {currentMonthData?.end_day}{t("total_rental_days_count_0417")}</span>
              </div>
            </div>
            <div className="flex-center column">
              <div className="flex-center column">
                <span className="sm_txt">{t("production_support_fund")}</span>
                <span className="b1_1">
                  <strong className="amount_txt">
                    {currentMonthData?.company_grant ? formatLocalString(currentMonthData.company_grant) : '0'}{t("won_0617")}
                  </strong>
                </span>
              </div> 
            </div>
          </li>
        )}
        {currentMonthData?.support_flag === 'Y' ?
        <li className="info_item">
          <div className="flex-center column">
            <span className="b1_1">
              <strong className="lg_txt">{lastMonthData?.month}</strong>{t("month_0617")}
            </span>
            <div className="flex-center-4 column info">
              <span className="sm_txt mt_10">{lastMonthData?.month}{t("month_0617")} {t("3_month_production_support_work")}</span>
              <span className="p3_1 ellipsis_clamp">{lastMonthData?.selected_work_titles}</span>
            </div>
          </div>
          <div className="flex-center column">
            <div className="flex-center column">
              <span className="sm_txt">{t("production_support_fund")}</span>
              <span className="b1_1">
                <strong className="amount_txt">
                  {lastMonthData?.company_grant ? formatLocalString(lastMonthData.company_grant) : '0'}{t("won_0617")}
                </strong>
              </span>
            </div>
          </div>
        </li>
        :
        <li className="info_item">
              <span className="p3_1 mt_10" >{t('production_support_ended')}</span>
        </li>
        }
      </ul>

      <ul className="resp_container support_list">
        {supportList.map((item, index) => (
          <li 
            key={index} 
            className="support_item"
            style={{cursor: 'pointer'}}
            onClick={() => handleViewMore(item.work_seq)}
          >
            <img src={item?.thumbnail} alt="event" loading="lazy"/>
            <div className="support_info">
              <span className="date">{item?.recruitment_year}{t("year_txt")} {item?.recruitment_month}{t("month_0617")}</span>
              <h6 className="title ellipsis1">{item?.work_title}</h6>
              <div className="detail">
                <p>DIRECTOR: {item?.director}</p>
                <p>{t("production_support_fund")}: {item?.company_grant ? formatLocalString(item.company_grant) : '0'}{t("won_0617")}</p>
              </div>
            </div>
          </li>
        ))}
      
      </ul>

      {totalCount > 0 && (
      <div className="pagination_wrap">
          <PaginationSection
              totalCount={totalCount}
              itemsPerPage={itemsPerPage}
              currentPage={currentPage}
              onPageChange={handlePageChange}
              onArrow={handleArrowClick}
          />
      </div>
      )}

      <SupportPopup
        isPopup={supportPop}
        setIsPopup={setSupportPop}
        commType="support"
        workSeq={selectedWorkSeq}
      />

      <SupportGuidePopup 
        isPopup={isSupportGuidePopup} 
        setIsPopup={setSupportGuidePopup}
        GuideData={currentMonthData?.guide_content}
      />

      <PopupLoginError 
        isPopup={isPopupLoginError} 
        setIsPopup={setIsPopupLoginError}
        onConfirm={handleConfirm}
      />

    </div>
  )
};

export default SupportList;